import { ModuleWithProviders } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ErrorComponent } from "@mango/core";
import { AuthGuard } from "@mango/authentication";
import { AUTHORIZATION_ROUTES } from "@mango/authorization";

import { BaseLayoutComponent } from "./shared/components/base-layout/base-layout.component";
import { PreloadAllModulesWithDelay } from "./preload";
import { withAngular12ListLook } from "./list-look";

// The screens are lazy loaded per feature (see the *.routes.ts files next to the components); the other
// features are loaded in the background shortly after the start (PreloadAllModulesWithDelay).
const routes: Routes = [
  {
    path: "",
    component: BaseLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: "frontdesk",
        pathMatch: "full"
      },
      {
        path: "frontdesk",
        loadChildren: () => import("./visitor/frontdesk.routes").then(m => m.FRONTDESK_ROUTES)
      },
      // A new role first gets its name only (see NewRoleComponent); this route comes before Mango's own roles routes
      {
        path: "authorization/roles/detail/new",
        loadComponent: () => import("./role/new-role.component").then(m => m.NewRoleComponent)
      },
      // Mango 22's AUTHORIZATION_ROUTES already contains the 'authorization' path (groups, roles, ...)
      ...withAngular12ListLook(AUTHORIZATION_ROUTES),
      {
        path: "users",
        loadChildren: () => import("./user/user.routes").then(m => m.USER_ROUTES)
      },
      {
        path: "alerts",
        loadChildren: () => import("./alert/alert.routes").then(m => m.ALERT_ROUTES)
      },
    ]
  },
  {
    path: "main",
    loadChildren: () => import("./main/main.routes").then(m => m.MAIN_ROUTES)
  },
  {
    path: "landing",
    redirectTo: "main/landing",
    pathMatch: "full"
  },
  {
    path: "error",
    component: ErrorComponent
  },
  {
    path: "activateAccount/:code",
    loadComponent: () => import("./login/activate-account/activate-account.component").then(m => m.SuselbeekActivateAccountComponent)
  },
  {
    path: "login",
    loadComponent: () => import("./login/login.component").then(m => m.AppLoginComponent)
  }
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModulesWithDelay });
